// src/locales/en.myProfile.ts

const myProfile = {  
////////////////////////////////////////////////////////////
//FollowersList
////////////////////////////////////////////////////////////

    followers: {
        title: "People Following You",
        search: {
          placeholder: "Search followers…",
          ariaLabel: "Search followers",
        },
        states: {
          loading: "Loading…",
          noMatches: "No matches.",
          noFollowers: "No followers yet.",
        },
        row: {
          followedYou: "Followed you:",
          noDate: "—",
        },
        buttons: {
          view: "View",
          moreActions: "More actions",
        },
        dropdown: {
          block: "Block",
          blockAndReport: "Block & Report",
        },
        block: {
          displayNameFallback: "this user",
          confirm:
            "Block {{displayName}}? They won't be able to interact with you, and you won't see each other’s posts or messages.",
          success: "User blocked.",
          failed: "Block failed",
        },
      },
   
////////////////////////////////////////////////////////////
//FollowingList
////////////////////////////////////////////////////////////

      followingList: {
        title: "People You Follow",
        searchPlaceholder: "Search profiles…",
        searchAria: "Search profiles",
        loading: "Loading…",
        emptyNoQuery: "You’re not following anyone yet.",
        emptyWithQuery: "No matches.",
        followedOn: "Followed on: {{date}}",
        followedOnUnknown: "Followed on: —",
        viewProfile: "View",
      
        blockConfirm:
          "Block {{name}}? They won't be able to interact with you, and you won't see each other’s posts or messages.",
        blockUnnamedUser: "this user",
        blockSuccess: "User blocked.",
        blockFailedFallback: "Block failed",
        moreActions: "More actions",
        block: "Block",
        blockAndReport: "Block & Report",
      },


////////////////////////////////////////////////////////////
//FollowingFeed
////////////////////////////////////////////////////////////

  followingFeed: {
    loading: "Loading your followees’ posts…",
    noPosts: "No posts from people you follow yet",
    unknownUser: "Unknown",
  },


////////////////////////////////////////////////////////////
//GalleryPostEditing
////////////////////////////////////////////////////////////

    galleryPostEditing: {
    title: "Edit Gallery Post",
  
    loading: "Loading...",
    noMedia: "No media in this post.",
  
    buttons: {
      saving: "Saving…",
      saveChanges: "Save Changes",
      cancelEdit: "Cancel Edit",
    },
  
    success: {
      updated: "✅ Post updated!",
    },
  
    errors: {
      invalidUrl: "❌ Invalid post URL.",
      notMedia: "⚠️ This editor supports media posts only.",
      notOwner: "⚠️ You are not authorized to edit this post.",
      loadFailed: "❌ Failed to load post.",
      notLoaded: "Post not loaded yet.",
      save401: "❌ Save failed (401). Please re-login and try again.",
      saveGeneric: "❌ Save failed. {{message}}",
    },
  },

////////////////////////////////////////////////////////////
//MyLikes and Modals
////////////////////////////////////////////////////////////

  MyLikes: {
    loading: "Loading your liked posts…",
    empty: "Nothing liked yet.",
    buttons: {
      chat: "Chat",
      },
    media: {
      previewAlt: "Preview",
      unknownTrack: "track",
      openDetails: "Open details for {{title}}",
      openUnknownDetails: "Open track details",
    },
    post: {
      unknownUser: "Unknown User",
      noMedia: "No media available",
      likedAt: "liked at {{date}}",
      presentationButton: "Presentation",
      likeButton: "❤️ Like ({{count}})",
      unlikeButton: "💔 Unlike ({{count}})",
    },
  },
    
    likes: {
      modalTitle: "❤️ Liked by",
    },

    likeListModal: {
        title: "Likes",
      
        actions: {
          close: "Close",
        },
      
        search: {
          placeholder: "Search by profilename…",
          ariaLabel: "Search likers by profilename",
        },
      
        loading: "Loading likes…",
      
        empty: {
          title: "No likes yet.",
          subtitle: "When people like this post, they’ll appear here.",
        },
      
        noMatches: {
          title: "No matches",
          subtitle: "Try a different name.",
        },
      
        unknownUser: "Unknown user",
      },

////////////////////////////////////////////////////////////
//MyPostings
////////////////////////////////////////////////////////////

      myPosts: {
        media: {
          remove: "Remove media",
          openDetails: "Open details for {{title}}",
          openUnknownDetails: "Open track details",
        },
        meta: {
          created: "{{datetime}} • {{type}}",
          location: "• 📍 {{city}}, {{country}}",
          likes: "• ❤️ {{count}} Likes",
          showLikesTooltip: "Show who liked this post",
          noMediaToOpen: "No media to open",
          openViewer: "Open viewer",
          presentation: "Presentation",
        },
        actions: {
          edit: "Edit Post",
          delete: "Delete Post",
          confirmDelete: "Delete this post? This cannot be undone. The post and its media will be permanently removed.",
          hide: "Hide Post",
          unhide: "Unhide Post",
          hideTooltip: "Hide post",
          unhideTooltip: "Unhide post",
          saving: "Saving…",
        },
        errors: {
          hideFailed: "Failed to hide post.",
          unhideFailed: "Failed to unhide post.",
        },
        loading: "Loading my posts...",
      },

////////////////////////////////////////////////////////////
//Notifications and Notification Sign
////////////////////////////////////////////////////////////

notifications: {
  open: "Open notifications",
  loading: "Loading Notifications...",
  delete: {
    confirm: "Are you sure you want to delete this notification?",
    tooltip: "Delete notification",
    deleting: "Deleting..."
  },
  common: {
    someone: "Someone",
  },
  filters: {
    all: "All",
    messages: "Messages",
    likes: "Likes",
    follow: "Follow",
  },
  empty: {
    all: "🔔 No notifications yet",
    chat: "💬 No messages yet",
    like: "🖼 No likes yet",
    follow: "👤 No follows yet",
  },
  like: {
    liked: "liked",
    yourPost: "your post",
    fromDate: "from {{date}}",
    unknownDate: "from an unknown date",
  },
  follow: {
    started: "started following you",
  },
  chat: {
    sentYouA: "sent you a",
    openChat: "Open chat",
    newMessage: "New message",
  },
  moderationmessage: {
    title: "Moderation",
    newMessage: "Your post have been removed from the public feed due to violation of our policy.",
  },
},

////////////////////////////////////////////////////////////
//Profile
////////////////////////////////////////////////////////////

      profile: {
        
        avatar: {
          change: "Change",
          help: "PNG/JPG • Max 10MB",
          clearSelection: "✖︎ Clear selection",
          removePicture: "👻 Remove picture",
        },
        fields: {
          profilenameLabel: "Profile Name (not changeable)",
          profilenamePlaceholder: "Your public name",
          locationLabel: "My Location (Optional)",
          locationPlaceholder: "Wherever",
          bioLabel: "What you need to know about me (Optional)",
          bioPlaceholder: "Short bio or something else",
        },   
        actions: {
          saving: "Saving…",
          save: "💾 Save changes",
        },
        messages: {
          updated: "✅ Profile updated!",
        },
        errors: {
          missingToken: "Missing auth token",
          fileTooLarge: "File too large (Worker MAX_UPLOAD_MB?)",
          updateFailed: "❌ Update failed",
          imageTooBig: "Please pick an image under 10 MB",
          imageType: "Please pick an image",
        },
      },

////////////////////////////////////////////////////////////
//Visitor Postings
///////////////////////////////////////////////////////////

      visitorPostings: {
  header: {
    name: "Name",
    location: "Location",
    about: "About",
  },
  buttons: {
    presentation: "🎬 Presentation",
  },
  avatar: {
    alt: "Profile picture",
  },
  loading: {
    profile: "Loading profile for {{name}}…",
  },
  scrollHint: {
    viewPosts: "Scroll down to view posts from {{name}}",
  },
  empty: {
    noPosts: "No posts yet",
  },
  restricted: {
    name: "User",
    bio: "This user's posts are hidden.",
  },
},
  
      

} as const;      
  
export default myProfile;